import { useMediaQuery } from 'react-responsive';
import { useTheme } from '../context';

export const useIsDesktop = () => {
  const { breakpoints } = useTheme();

  return useMediaQuery({ minWidth: breakpoints.m });
};
